/**
 * OA Product Switcher — Variant image swatches for Shopify
 * 100% client-side. No server needed.
 * By Online Actief (online-actief.nl)
 */
(() => {
  'use strict';

  /* ── Config helpers ── */
  function cfg() { return window.OASwatchConfig || {}; }
  function s(key, fallback) {
    var val = (cfg().settings || {})[key];
    if (val === undefined || val === '' || val === 'auto') return fallback;
    return val;
  }

  /* ── Product data cache ── */
  var cache = {};
  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function(p) { cache[handle] = p; return p; });
  }

  function currentPageProduct() {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var d = JSON.parse(scripts[i].textContent);
        var p = d && d.variants ? d : (d && d.product && d.product.variants ? d.product : null);
        if (p && p.handle) { cache[p.handle] = p; return Promise.resolve(p); }
      } catch(e) {}
    }
    var handle = window.ShopifyAnalytics?.meta?.product?.handle;
    if (handle) return fetchProduct(handle);
    var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (m) return fetchProduct(m[1]);
    return Promise.reject('no product');
  }

  /* ── Option name filter ── */
  function shouldShowOption(name) {
    var filter = s('optionNames', 'alle');
    if (!filter || filter.toLowerCase().trim() === 'alle') return true;
    var names = filter.split(',').map(function(n) { return n.trim().toLowerCase(); });
    return names.indexOf(name.toLowerCase().trim()) !== -1;
  }

  /* ── Variant helpers ── */
  function findVariant(product, opts) {
    return product.variants.find(function(v) {
      for (var i = 0; i < product.options.length; i++) {
        if (opts[i] !== undefined && v['option' + (i + 1)] !== opts[i]) return false;
      }
      return true;
    });
  }

  function variantImage(product, optIdx, val) {
    var key = 'option' + (optIdx + 1);
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (v[key] === val && v.featured_image && v.featured_image.src) {
        return v.featured_image.src;
      }
    }
    if (product.images) {
      for (var i = 0; i < product.images.length; i++) {
        var img = product.images[i];
        var alt = (typeof img === 'string' ? '' : (img.alt || '')).toLowerCase();
        if (alt && alt.indexOf(val.toLowerCase()) !== -1) {
          return typeof img === 'string' ? img : img.src;
        }
      }
    }
    return null;
  }

  function variantPrice(product, optIdx, val) {
    var key = 'option' + (optIdx + 1);
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i][key] === val && product.variants[i].available) {
        return product.variants[i].price;
      }
    }
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i][key] === val) return product.variants[i].price;
    }
    return null;
  }

  function isAvailable(product, optIdx, val, selected) {
    var key = 'option' + (optIdx + 1);
    return product.variants.some(function(v) {
      if (v[key] !== val) return false;
      for (var j = 0; j < product.options.length; j++) {
        if (j === optIdx) continue;
        if (selected[j] && v['option' + (j + 1)] !== selected[j]) return false;
      }
      return v.available;
    });
  }

  function sizePx(isCard) {
    if (isCard) return { small: 28, medium: 36, large: 48 }[s('cardSwatchSize', 'small')] || 28;
    return { small: 48, medium: 64, large: 80, xlarge: 100 }[s('swatchSize', 'medium')] || 64;
  }

  function formatPrice(cents) {
    if (!cents && cents !== 0) return '';
    var currency = window.Shopify?.currency?.active || 'EUR';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency, minimumFractionDigits: 2 });
  }

  function imgSize(src, size) {
    if (!src) return '';
    return src.replace(/(\.[^.]+)$/, '_' + size + '$1').replace(/\?.*/, '');
  }

  /* ── Selectors ── */
  var FORM_SEL = [
    'form[action*="/cart/add"]', '.product-form', '.product-single__form',
    '.product__form', '.ProductForm', 'product-form'
  ];
  var VARIANT_SEL = [
    'variant-selects', 'variant-radios', '.product-form__input',
    '.selector-wrapper', '.SingleOptionSelector', 'fieldset.product-form__input',
    '.product-form__controls-group', '.variant-wrapper'
  ];
  var CARD_SEL = [
    '.product-grid-item', '.product__grid__item',
    '.card-wrapper', '.product-card-wrapper', '.grid-product', '.product-card',
    '.grid__item .grid-view-item', '.collection-product-card', '.ProductItem', '.product-index'
  ];

  function qs(sel) { try { return document.querySelector(sel); } catch(e) { return null; } }
  function qsa(sel) { try { return document.querySelectorAll(sel); } catch(e) { return []; } }

  function findForm() {
    var custom = s('productFormSelector', '');
    if (custom) { var el = qs(custom); if (el) return el; }
    for (var i = 0; i < FORM_SEL.length; i++) { var el = qs(FORM_SEL[i]); if (el) return el; }
    return null;
  }
  function findCards() {
    var custom = s('cardSelector', '');
    if (custom) { var els = qsa(custom); if (els.length) return els; }
    for (var i = 0; i < CARD_SEL.length; i++) { var els = qsa(CARD_SEL[i]); if (els.length) return els; }
    return [];
  }

  /* ══════════════════════════════════════
     PRODUCT PAGE
     ══════════════════════════════════════ */

  function initProduct() {
    if (s('enableProductPage', true) === false) return;
    if (qs('[data-oa-swatch-init]')) return;

    currentPageProduct().then(function(product) {
      if (!product || !product.variants || product.variants.length <= 1) return;

      var form = findForm();
      if (!form) return;

      var urlVid = new URLSearchParams(window.location.search).get('variant');
      var cur = null;
      if (urlVid) cur = product.variants.find(function(v) { return String(v.id) === urlVid; });
      if (!cur) cur = product.variants.find(function(v) { return v.available; }) || product.variants[0];

      var selected = [];
      product.options.forEach(function(_, i) { selected[i] = cur['option' + (i + 1)]; });

      var container = document.createElement('div');
      container.className = 'oa-sw';
      container.dataset.oaSwatchInit = 'true';

      var radius = s('borderRadius', 6);
      var style = s('swatchStyle', 'image');
      var size = sizePx(false);

      product.options.forEach(function(optName, optIdx) {
        if (!shouldShowOption(optName)) return;

        var values = [];
        product.variants.forEach(function(v) {
          var val = v['option' + (optIdx + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        if (values.length <= 1 && values[0] === 'Default Title') return;

        var optWrap = document.createElement('div');
        optWrap.className = 'oa-sw-opt';

        if (s('showOptionLabel', true)) {
          var lbl = document.createElement('div');
          lbl.className = 'oa-sw-lbl';
          lbl.innerHTML = '<strong>' + optName + ':</strong> <span data-oa-lbl="' + optIdx + '">' + selected[optIdx] + '</span>';
          optWrap.appendChild(lbl);
        }

        var row = document.createElement('div');
        row.className = 'oa-sw-row';

        values.forEach(function(val) {
          var img = variantImage(product, optIdx, val);
          var price = variantPrice(product, optIdx, val);
          var avail = isAvailable(product, optIdx, val, selected);
          var active = val === selected[optIdx];

          var swatch = document.createElement('button');
          swatch.type = 'button';
          swatch.className = 'oa-sw-item';
          swatch.dataset.idx = optIdx;
          swatch.dataset.val = val;
          if (active) swatch.classList.add('oa-sw-active');
          if (!avail) swatch.classList.add('oa-sw-sold');
          if (!avail && s('unavailableStyle', 'crossout') === 'hide') swatch.style.display = 'none';

          if (style === 'button') {
            swatch.classList.add('oa-sw-btn');
            var inner = '<span class="oa-sw-btn-text">' + val + '</span>';
            if (s('showPrice', false) && price !== null) {
              inner += '<span class="oa-sw-btn-price">' + formatPrice(price) + '</span>';
            }
            swatch.innerHTML = inner;
          } else {
            var thumb = document.createElement('div');
            thumb.className = 'oa-sw-thumb';
            thumb.style.width = size + 'px';
            thumb.style.height = size + 'px';
            thumb.style.borderRadius = radius + 'px';

            if (img) {
              var imgEl = document.createElement('img');
              imgEl.src = imgSize(img, size * 2 + 'x' + size * 2);
              imgEl.alt = val;
              imgEl.loading = 'lazy';
              imgEl.draggable = false;
              thumb.appendChild(imgEl);
            } else {
              thumb.classList.add('oa-sw-thumb-empty');
              thumb.textContent = val.substring(0, 3);
            }
            swatch.appendChild(thumb);

            if (style === 'image-label') {
              var lb = document.createElement('span');
              lb.className = 'oa-sw-item-lbl';
              lb.textContent = val;
              swatch.appendChild(lb);
            }
            if (s('showPrice', false) && price !== null) {
              var pr = document.createElement('span');
              pr.className = 'oa-sw-item-price';
              pr.textContent = formatPrice(price);
              swatch.appendChild(pr);
            }
          }

          if (s('showTooltip', true) && style === 'image') {
            var tip = document.createElement('span');
            tip.className = 'oa-sw-tip';
            tip.textContent = val;
            swatch.appendChild(tip);
          }

          swatch.addEventListener('click', function() {
            selected[optIdx] = val;
            refreshSwatches(container, product, selected);
            applyVariant(product, selected, form);
          });

          row.appendChild(swatch);
        });

        optWrap.appendChild(row);
        container.appendChild(optWrap);
      });

      /* Insert & hide originals */
      var originals = [];
      VARIANT_SEL.forEach(function(sel) {
        form.querySelectorAll(sel).forEach(function(el) {
          if (el.querySelector('select, input[type="radio"]') || el.tagName === 'VARIANT-SELECTS' || el.tagName === 'VARIANT-RADIOS') {
            originals.push(el);
          }
        });
      });

      if (originals.length) {
        originals[0].parentNode.insertBefore(container, originals[0]);
        originals.forEach(function(el) { el.style.display = 'none'; });
      } else {
        form.insertBefore(container, form.firstChild);
      }
    }).catch(function(e) { /* silent */ });
  }

  function refreshSwatches(container, product, selected) {
    container.querySelectorAll('.oa-sw-item').forEach(function(sw) {
      var idx = parseInt(sw.dataset.idx);
      var val = sw.dataset.val;
      sw.classList.toggle('oa-sw-active', val === selected[idx]);
      var avail = isAvailable(product, idx, val, selected);
      sw.classList.toggle('oa-sw-sold', !avail);
      if (s('unavailableStyle', 'crossout') === 'hide') sw.style.display = avail ? '' : 'none';
    });
    container.querySelectorAll('[data-oa-lbl]').forEach(function(el) {
      el.textContent = selected[parseInt(el.dataset.oaLbl)];
    });
  }

  function applyVariant(product, selected, form) {
    var variant = findVariant(product, selected);
    if (!variant) return;

    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    if (idInput) { idInput.value = variant.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }

    /* Sync selects */
    var selects = form.querySelectorAll('select:not([name="id"])');
    selected.forEach(function(val, i) {
      if (selects[i]) {
        for (var j = 0; j < selects[i].options.length; j++) {
          if (selects[i].options[j].value === val) { selects[i].selectedIndex = j; break; }
        }
        selects[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    /* Sync radios */
    selected.forEach(function(val, i) {
      form.querySelectorAll('input[type="radio"]').forEach(function(r) {
        if (r.value === val) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });

    /* URL */
    var url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);

    /* Product image fade-swap */
    if (variant.featured_image && variant.featured_image.src) {
      var mainImg = qs('.product__media img, .product-single__photo img, .product__images img, .product-featured-media img, [data-product-featured-image], .product__main-photos img');
      if (mainImg) {
        mainImg.style.transition = 'opacity 0.2s';
        mainImg.style.opacity = '0';
        setTimeout(function() {
          mainImg.src = imgSize(variant.featured_image.src, '1024x1024');
          mainImg.srcset = '';
          mainImg.style.opacity = '1';
        }, 150);
      }
    }

    /* Price */
    var priceEl = qs('.price__regular .price-item--regular, .product__price, .product-single__price, .ProductMeta__Price, [data-product-price]');
    if (priceEl && variant.price !== undefined) priceEl.textContent = formatPrice(variant.price);

    var compareEl = qs('.price__sale .price-item--regular, .product__price--compare, .product-single__price--compare, [data-compare-price]');
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatPrice(variant.compare_at_price);
        compareEl.style.display = '';
      } else { compareEl.style.display = 'none'; }
    }

    /* Add to cart */
    var btn = form.querySelector('[type="submit"], .product-form__submit, .btn--add-to-cart');
    if (btn) { btn.disabled = !variant.available; }

    window.dispatchEvent(new CustomEvent('oa:variant:change', { detail: { variant: variant } }));
  }

  /* ══════════════════════════════════════
     COLLECTION CARDS
     ══════════════════════════════════════ */

  function initCards() {
    if (s('enableCollectionCards', true) === false) return;

    var cards = findCards();
    var cardSize = sizePx(true);
    var radius = s('borderRadius', 6);

    Array.from(cards).forEach(function(card) {
      if (card.querySelector('.oa-sw-card')) return;

      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var parts = (link.getAttribute('href') || '').split('/products/');
      if (parts.length < 2) return;
      var handle = parts[1].split('?')[0].split('#')[0];
      if (!handle) return;

      fetchProduct(handle).then(function(product) {
        if (!product || product.variants.length <= 1) return;
        if (!shouldShowOption(product.options[0])) return;

        var values = [];
        product.variants.forEach(function(v) {
          if (v.option1 && values.indexOf(v.option1) === -1) values.push(v.option1);
        });
        if (values.length <= 1) return;

        var row = document.createElement('div');
        row.className = 'oa-sw-card';

        var maxShow = 5;
        values.slice(0, maxShow).forEach(function(val) {
          var img = variantImage(product, 0, val);

          var dot = document.createElement('span');
          dot.className = 'oa-sw-card-dot';
          dot.title = val;
          dot.style.width = cardSize + 'px';
          dot.style.height = cardSize + 'px';
          dot.style.borderRadius = radius + 'px';

          if (img) {
            dot.style.backgroundImage = 'url(' + imgSize(img, '100x100') + ')';
            dot.style.backgroundSize = 'cover';
            dot.style.backgroundPosition = 'center';
          } else {
            dot.textContent = val.substring(0, 2);
            dot.classList.add('oa-sw-card-txt');
          }

          if (s('changeCardImage', true) && img) {
            dot.addEventListener('mouseenter', function() {
              var ci = card.querySelector('img');
              if (!ci) return;
              if (!ci.dataset.oaOrig) ci.dataset.oaOrig = ci.src;
              ci.style.transition = 'opacity 0.2s';
              ci.style.opacity = '0.5';
              ci.src = imgSize(img, '600x600');
              setTimeout(function() { ci.style.opacity = '1'; }, 100);
            });
            dot.addEventListener('mouseleave', function() {
              var ci = card.querySelector('img');
              if (ci && ci.dataset.oaOrig) ci.src = ci.dataset.oaOrig;
            });
          }

          dot.style.cursor = 'pointer';
          dot.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var v = product.variants.find(function(x) { return x.option1 === val; });
            if (v) window.location.href = '/products/' + handle + '?variant=' + v.id;
          });

          row.appendChild(dot);
        });

        if (values.length > maxShow) {
          var more = document.createElement('span');
          more.className = 'oa-sw-card-more';
          more.textContent = '+' + (values.length - maxShow);
          row.appendChild(more);
        }

        var target = card.querySelector('.card__content, .card-information, .grid-product__meta, .product-card__info, .ProductItem__Info');
        (target || card).appendChild(row);
      }).catch(function() {});
    });
  }

  /* ── Boot ── */
  function boot() {
    document.documentElement.style.setProperty('--oa-sw-border-color', s('selectedBorderColor', '#1d1d1b'));
    document.documentElement.style.setProperty('--oa-sw-border-w', s('selectedBorderWidth', 2) + 'px');
    document.documentElement.style.setProperty('--oa-sw-radius', s('borderRadius', 6) + 'px');
    initProduct();
    initCards();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);

  new MutationObserver(function(muts) {
    if (muts.some(function(m) { return Array.from(m.addedNodes).some(function(n) { return n.nodeType === 1 && n.querySelector && n.querySelector('a[href*="/products/"]'); }); }))
      setTimeout(initCards, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
